var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoDoctor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M672.594 225.5H597.708V146.021C597.708 89.2029 552.874 43 495.904 43H304.111C247.111 43 202.292 89.2029 202.292 146.021V225.5H127.391C76.3515 225.5 35 264.905 35 315.792V665.69C35 716.562 76.3515 757.792 127.391 757.792H672.594C723.618 757.792 765 716.562 765 665.675V315.792C765 264.905 723.618 225.5 672.594 225.5ZM263.125 146.021C263.125 124.745 282.774 103.833 304.111 103.833H495.904C517.18 103.833 536.875 124.745 536.875 146.021V225.5H263.125V146.021ZM567.292 560.083H460.833V666.542H339.167V560.083H232.708V438.417H339.167V331.958H460.833V438.417H567.292V560.083Z",
    fill: "#062134"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDoctor);
export default __webpack_public_path__ + "static/media/ico_doctor.426c880cc4664f29db9a55b5ac0c9020.svg";
export { ForwardRef as ReactComponent };